import { ComponentClassNames } from '../../../../util/classNames';
import { getGutterValue } from '../../../../util/styles/gutters';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';

import { headerHeight } from './HeaderRow.types';

type GetClassNames = (
  mainAreaHeight: number,
  gutterSize: number
) => ComponentClassNames<'leftNavPositionWrapper' | 'scrollablePaddingWrapper'>;

export const getClassNames: GetClassNames = memoizeFunction((mainAreaHeight, gutterSize) => {
  const fallbackHeight = `calc(100vh - ${headerHeight}px)`;
  const height = mainAreaHeight || fallbackHeight;

  return mergeStyleSets({
    leftNavPositionWrapper: {
      position: 'fixed',
      width: 'inherit',
      height,
    },
    scrollablePaddingWrapper: {
      paddingTop: getGutterValue(gutterSize),
    },
  });
});
